import FeedbackFormContext, {
  IFeedbackContext,
} from '@providers/feedbackFormProvider'
import { useContext } from 'react'

export default function useFeedback(): IFeedbackContext {
  return useContext(FeedbackFormContext)
}
